import { useSelector } from "react-redux";
import AuthController from "../../Controllers/AuthController";
import { CALLBACK_STATUS, LOGIN_REDIRECT_PATH } from "../Consts";
import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "../../Components/ui/use-toast";
// import { useNavigate } from "react-router-dom";

export const useAuth = () => {
  const session = useSelector((state) => state.Auth.session);
  const navigate = useNavigate();

  const loginRedirect = useRef(LOGIN_REDIRECT_PATH);
  const loginInFlightRef = useRef(false);

  const handleLogin = useCallback(
    async (data = { email: "", password: "" }, callback) => {
      if (loginInFlightRef.current) return;
      loginInFlightRef.current = true;

      try {
        callback && callback(CALLBACK_STATUS.LOADING, true);
        AuthController.clearCredentials();
        const res = await AuthController.signIn(data);
        console.log(res, "@auth login res");

        // Only persist credentials + navigate if full session returned
        if (res?.user && res?.accessToken) {
          AuthController.persistCredentials(res);
          navigate(loginRedirect.current);
        }

        callback && callback(CALLBACK_STATUS.SUCCESS, res);
      } catch (error) {
        callback && callback(CALLBACK_STATUS.ERROR, error);
      } finally {
        loginInFlightRef.current = false;
        callback && callback(CALLBACK_STATUS.LOADING, false);
      }
    },
    [navigate]
  );

  const handleResetPassword = useCallback(
    async (data = { password: "" }, callback) => {
      try {
        callback && callback(CALLBACK_STATUS.LOADING, true);
        const res = await AuthController.resetPassword(data);
        console.log(res, "@reset password res");
        if (res?.user && res?.accessToken) {
          AuthController.persistCredentials(res);
        }
        callback && callback(CALLBACK_STATUS.SUCCESS, res);
      } catch (error) {
        callback && callback(CALLBACK_STATUS.ERROR, error);
      } finally {
        callback && callback(CALLBACK_STATUS.LOADING, false);
      }
    },
    []
  );

  const handleNotificationPreferences = useCallback(
    async (data = { newProvider: true }, callback) => {
      try {
        callback && callback(CALLBACK_STATUS.LOADING, true);
        const res = await AuthController.notificationPreferences(data);
        console.log(res, "@notification preferences res");
        AuthController.persistCredentials({ ...session, user: res?.user });
        callback && callback(CALLBACK_STATUS.SUCCESS, res);
      } catch (error) {
        callback && callback(CALLBACK_STATUS.ERROR, error);
      } finally {
        callback && callback(CALLBACK_STATUS.LOADING, false);
      }
    },
    []
  );
  useEffect(() => {
    console.log(session, "@auth");
  }, [session]);

  const handleLogout = async () => {
    const logout = toast({
      title: "Logging out",
      description: "Your account is in logging out!",
      status: "loading",
      variant: "loading",
      loading: true,
    });
    await AuthController.logout();
    logout?.dismiss();
  };

  return {
    handleLogin,
    handleNotificationPreferences,
    handleLogout,
    handleResetPassword,
    user: session?.user || null,
    token: session?.accessToken || null,
    authenticated:
      session?.accessToken && session?.user && session?.user?.isPasswordReset
        ? true
        : false,
    session,
    loginRedirect: loginRedirect.current,
    isPasswordReset: session?.user?.isPasswordReset,
  };
};
